export { useFastshiftPageAnalytics } from "./use-fastshift-page-analytics";
export { useFastshiftUIAnalytics } from "./use-fastshift-ui-analytics";
